// Section - 6 [SALES LINKS] ________________________________________________________________________
function initProductList() {
    const list = document.getElementById('productList');
    const descD = document.getElementById('descDesktop');
    const descM = document.getElementById('descMobile');
    const imgEl = document.getElementById('productImage');

    if (!list || !descD || !descM || !imgEl) return;

    function setActive(btn) {
        list.querySelectorAll('.product-item').forEach((el) => {
            el.classList.remove('opacity-100', 'font-medium');
            el.classList.add('opacity-70');
        });
        btn.classList.remove('opacity-70');
        btn.classList.add('opacity-100', 'font-medium');
    }

    function updateFrom(btn) {
        const { desc, img } = btn.dataset;

        if (desc) {
            descD.textContent = desc;
            descM.textContent = desc;
        }

        if (img) imgEl.src = img;

        setActive(btn);
    }

    list.addEventListener('click', (e) => {
        const btn = e.target.closest('.product-item');
        if (!btn) return;
        updateFrom(btn);
    });

    const first = list.querySelector('.product-item');
    if (first) updateFrom(first);
}

initProductList();
